import { FloatingFilterButton } from '~shared/ui/floating-filter-button';

import { BusinessSelect, StatusSelect } from './payments-filter-fields';

type Props = {
  hideMerchantFilter: boolean;
  activeCount: number;
  onApply: () => void;
  onClear: () => void;
};

export function PaymentsFiltersMobile({
  hideMerchantFilter,
  activeCount,
  onApply,
  onClear,
}: Props) {
  return (
    <FloatingFilterButton
      activeCount={activeCount}
      onApply={onApply}
      onClear={onClear}
    >
      <StatusSelect />
      {!hideMerchantFilter && <BusinessSelect />}
    </FloatingFilterButton>
  );
}
